

















import {defineComponent, PropType} from '@vue/composition-api';
import {useVModel} from '@vueuse/core';
import TaskState from '@/task-states/models/TaskState';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default defineComponent({
  name: 'TextareaUiComponent',
  components: {StembleLatex},
  props: {
    answer: {
      type: String as PropType<string | null>,
    },
    allowEditing: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    placeholder: {
      type: String as PropType<string>,
      default: null,
    },
    taskState: {
      type: Object as PropType<TaskState | null>,
      default: null,
    },
    label: {
      type: String as PropType<string>,
      default: null,
    },
  },
  emits: {
    'update:answer': (answer: string) => null,
  },
  setup(props) {
    const answerModel = useVModel(props, 'answer');
    const inputId = Math.random().toString(36).substring(7);

    return {answerModel, inputId};
  },
});
